export default __webpack_public_path__ + "static/media/Zone-Master-Plan-Type-C.d270cdfd.png";